import { useMemo, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import ImageSlider from "./slider";
import { useCart } from "../../context/CartContext";

import kaka3 from "../../resources/pontunarkokur/bjossi3.jpg";
import kaka7 from "../../resources/pontunarkokur/bjossi7.jpg";
import kaka8 from "../../resources/pontunarkokur/bjossi8.jpg";
import kaka9 from "../../resources/pontunarkokur/bjossi9.jpg";
import kaka10 from "../../resources/pontunarkokur/bjossi10.jpg";
import marsipan10 from "../../resources/pontunarkokur/marsipan10.JPG";
import marsipan1 from "../../resources/pontunarkokur/Marsipan-kaka.PNG";
import marsipan2 from "../../resources/pontunarkokur/marsipan2.JPG";
import marsipan3 from "../../resources/pontunarkokur/marsipan3.JPG";
import marsipan4 from "../../resources/pontunarkokur/marsipan4.JPG";
import heidda1 from "../../resources/pontunarkokur/heidda1.JPG";
import heidda2 from "../../resources/pontunarkokur/Smjorkremstertur.JPG";
import heidda3 from "../../resources/pontunarkokur/Smjorkremstertus.JPG";
import heidda4 from "../../resources/pontunarkokur/heidda4.JPG";
import heidda5 from "../../resources/pontunarkokur/heidda5.JPG";
import heidda6 from "../../resources/pontunarkokur/heidda6.JPG";
import heidda7 from "../../resources/pontunarkokur/heidda7.JPG";
import heidrun1 from "../../resources/pontunarkokur/heiddukaka3.jpg";
import heidrun2 from "../../resources/pontunarkokur/heiddukaka4.jpg";
import heidrun3 from "../../resources/pontunarkokur/heiddukaka5.jpg";
import kaka16 from "../../resources/pontunarkokur/afmælis_minecraft.jpeg";
import kaka17 from "../../resources/pontunarkokur/afmæliskaka.jpeg";
import braudterta1 from "../../resources/pontunarkokur/braudterta.jpeg";
import ricecrispies from "../../resources/pontunarkokur/ricecrispturn.jpeg";
import ricecrispies2 from "../../resources/pontunarkokur/Rice-crispies.JPG";
import kranskaka2 from "../../resources/pontunarkokur/kranskakaka2.jpeg";
import ferming1 from "../../resources/pontunarkokur/ferming1.jpeg";
import ferming2 from "../../resources/pontunarkokur/ferming2.jpeg";
import ferming3 from "../../resources/pontunarkokur/ferming3.jpeg";
import skirnarkoddar1 from "../../resources/pontunarkokur/skirnarkoddi.jpeg";
import afmælismynd1 from "../../resources/pontunarkokur/afmælis-ia.jpg";
import fronsksukk from "../../resources/pontunarkokur/fronsk-sukk.jpg";
import amerisksukk from "../../resources/pontunarkokur/amerisk-sukkulaði.jpg";

const CAKES = [
  {
    id: 2, name: "Smjörkremskaka",
    size: [
      { size: "12-15 manna", price: 16400 }, { size: "20-25 manna", price: 21500 },
      { size: "25-30 manna", price: 26500 }, { size: "35-40 manna", price: 30500 },
    ],
    botnar: ["Súkkulaðibotnar", "Vanillubotnar", "Karamellubotnar"],
    smjorkrem: ["Súkkulaði", "Vanillu", "Saltkaramellu", "Oreo", "Jarðaberja", "Hindberja", "Dumle", "Biscoff"],
  },
  {
    id: 1, name: "Marsipantertur",
    size: [
      { size: "12 manna", price: 12000 }, { size: "16 manna", price: 13500 },
      { size: "20 manna", price: 16500 }, { size: "30 manna", price: 24000 },
      { size: "40 manna", price: 30500 }, { size: "50 manna", price: 36500 },
      { size: "60 manna", price: 41500 },
    ],
    fillings: ["Sælgætis m/marsbitum", "Jarðaberja", "Sherrý", "Súkkulaði", "Karamellu/krókant", "Hindberja", "Bananasplitt", "Karamellu-daim"],
  },
  
  {
    id: 3, name: "Skírnarkoddar",
    size: [{ size: "20 manna", price: 19500 }, { size: "30 manna", price: 25500 }, { size: "40 manna", price: 33000 }],
    fillings: ["Sælgætis m/marsbitum", "Jarðaberja", "Sherrý", "Súkkulaði", "Karamellu/krókant", "Hindberja", "Bananasplitt", "Karamellu-daim"],
  },
  {
    id: 4, name: "Afmælistertur",
    size: [{ size: "20 manna", price: 10000 }, { size: "30 manna", price: 12000 }, { size: "40 manna", price: 14000 }],
  },
  {
    id: 10, name: "Afmælistertur með mynd",
    size: [{ size: "20 manna", price: 12000 }, { size: "30 manna", price: 14000 }, { size: "40 manna", price: 16000 }],
    needsImage: true,
  },
  {
    id: 5, name: "Brauðtertur",
    size: [{ size: "16 manna", price: 13500 }, { size: "20 manna", price: 16500 }, { size: "30 manna", price: 23400 }, { size: "40 manna", price: 27400 }],
    fillings: ["Skinku", "Túnfisk", "Rækju"],
  },
  {
    id: 7, name: "Fermingarbækur",
    size: [{ size: "30 manna", price: 29000 }, { size: "40 manna", price: 36000 }, { size: "50 manna", price: 43500 }, { size: "60 manna", price: 49500 }],
    fillings: ["Sælgætis m/marsbitum", "Jarðaberja", "Sherrý", "Súkkulaði", "Karamellu/krókant", "Hindberja", "Bananasplitt", "Karamellu-daim"],
  },
  {
    id: 8, name: "Kransakökur",
    size: [{ size: "20 manna", price: 21400 }, { size: "30 manna", price: 29000 }, { size: "40 manna", price: 34500 }],
  },
  {
    id: 11, name: "Frönsk súkkulaðiterta",
    size: [
      { size: "16 manna", price: 12300 }, { size: "20 manna", price: 15000 },
      { size: "30 manna", price: 21750 }, { size: "40 manna", price: 28500 },
      { size: "50 manna", price: 35250 }, { size: "60 manna", price: 40500 },
    ],
  },
  {
    id: 12, name: "Rice Crispies turn",
    size: [{ size: "30 manna", price: 21400 }, { size: "40 manna", price: 29000 }],
  },
  {
    id: 9, name: "Amerísk súkkulaði",
    size: [
      { size: "16 manna", price: 12300 }, { size: "20 manna", price: 14500 },
      { size: "30 manna", price: 19900 }, { size: "40 manna", price: 24500 },
      { size: "50 manna", price: 31500 }, { size: "60 manna", price: 37500 },
    ],
  },
  {
    id: 6, name: "Marengsterta",
    size: [{ size: "30 manna", price: 20200 }, { size: "40 manna", price: 25700 }, { size: "50 manna", price: 31200 }],
  },
];

const IMAGES_BY_NAME = {
  Smjörkremskaka: [heidda3, heidda4, heidrun1, heidrun2, heidrun3, heidda5, heidda6, heidda2, heidda7],
  Marsipantertur: [marsipan10, marsipan1, marsipan2, marsipan3, marsipan4, kaka3, kaka7, kaka8, kaka9, kaka10],
Afmælistertur: [kaka17],
  Brauðtertur: [braudterta1],
  "Rice Crispies turn": [ricecrispies, ricecrispies2],
  Kransakökur: [kranskaka2],
  Fermingarbækur: [ferming1, ferming2, ferming3],
  Skírnarkoddar: [skirnarkoddar1],
  "Afmælistertur með mynd": [kaka16, afmælismynd1],
  "Frönsk súkkulaðiterta": [fronsksukk],
  "Amerísk súkkulaði": [amerisksukk],
};

const formatISK = (n) =>
  typeof n === "number" ? new Intl.NumberFormat("is-IS").format(n) + " kr." : "";

const INPUT_CLS = "w-full h-11 px-4 bg-white border border-amber-200 rounded-xl text-stone-800 font-serif text-sm focus:outline-none focus:ring-2 focus:ring-[#C29979]/30";
const SELECT_CLS = INPUT_CLS;
const LABEL_CLS = "block text-xs font-semibold text-stone-500 uppercase tracking-wide mb-1.5";

// ── Detail panel (image left, form right, no tabs) ─────────────────
const CakeDetail = ({ cake, images }) => {
  const { addItems } = useCart();
  const [draft, setDraft] = useState({ size: "", filling: "", bottom: "", smjorkrem: "", text: "", skreyting: "" });
  const [err, setErr] = useState("");
  const [added, setAdded] = useState(false);

  const set = (key, val) => setDraft(d => ({ ...d, [key]: val }));
  const selectedSize = cake.size?.find(s => s.size === draft.size) ?? (cake.size?.length === 1 ? cake.size[0] : null);

  const showSkreyting = ["Marsipantertur", "Skírnarkoddar", "Fermingarbækur", "Smjörkremskaka"].includes(cake.name);

  const handleAdd = () => {
    setErr("");
    if (cake.size?.length > 1 && !draft.size) return setErr("Vinsamlegast veldu stærð.");
    if (cake.fillings?.length && !draft.filling) return setErr("Vinsamlegast veldu fyllingu.");
    if (cake.botnar?.length && !draft.bottom) return setErr("Vinsamlegast veldu botn.");
    if (cake.smjorkrem?.length && !draft.smjorkrem) return setErr("Vinsamlegast veldu smjörkrem.");

    const size = draft.size || (cake.size?.[0]?.size ?? "");
    const price = selectedSize?.price ?? cake.size?.[0]?.price ?? 0;

    addItems([{
      cartId: uuidv4(), type: "cake",
      label: `${cake.name}${size ? ` – ${size}` : ""}`,
      price,
      details: { cake: cake.name, size, filling: draft.filling, bottom: draft.bottom, smjorkrem: draft.smjorkrem, text: draft.text, skreyting: draft.skreyting, needsImage: !!cake.needsImage },
    }]);

    setAdded(true);
    setTimeout(() => { setAdded(false); setDraft({ size: "", filling: "", bottom: "", smjorkrem: "", text: "", skreyting: "" }); }, 2500);
  };

  return (
    <div className="flex flex-col lg:flex-row gap-6 lg:gap-8">

      {/* Left: image */}
      <div className="w-full lg:w-[45%] flex-shrink-0">
        {images.length > 0 ? (
          <div className="rounded-2xl overflow-hidden border border-amber-100 aspect-[4/3]">
            <ImageSlider images={images} />
          </div>
        ) : (
          <div className="rounded-2xl border border-amber-100 bg-amber-50 aspect-[4/3] flex items-center justify-center">
            <span className="text-stone-300 font-serif text-sm">Engin mynd</span>
          </div>
        )}
      </div>

      {/* Right: name + form */}
      <div className="flex-1 min-w-0 flex flex-col gap-4">
        <h2 className="text-2xl font-serif font-bold text-stone-900 leading-snug">{cake.name}</h2>

        {added ? (
          <div className="rounded-xl border border-emerald-200 bg-emerald-50 p-4 text-center">
            <p className="text-emerald-700 font-serif font-semibold">✓ Bætt í körfu!</p>
            <a href="/karfa" className="text-[#C29979] text-sm font-serif underline mt-1 block">Fara í körfu →</a>
          </div>
        ) : (
          <>
            {/* Sizes as clickable cards */}
            {cake.size?.length > 0 && (
              <div>
                <p className={LABEL_CLS}>Stærð</p>
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
                  {cake.size.map(s => (
                    <button
                      key={s.size}
                      type="button"
                      onClick={() => set("size", s.size)}
                      className={`text-left px-3 py-2.5 rounded-xl border transition-colors ${
                        draft.size === s.size
                          ? "border-[#C29979] bg-amber-50"
                          : "border-amber-100 bg-white hover:border-[#C29979]/50"
                      }`}
                    >
                      <div className={`font-serif text-xs leading-tight ${draft.size === s.size ? "text-[#C29979] font-semibold" : "text-stone-500"}`}>{s.size}</div>
                      <div className={`font-serif text-sm font-semibold mt-0.5 ${draft.size === s.size ? "text-stone-900" : "text-stone-700"}`}>{formatISK(s.price)}</div>
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* Filling */}
            {cake.fillings?.length > 0 && (
              <div>
                <label className={LABEL_CLS}>Fylling</label>
                <select className={SELECT_CLS} value={draft.filling} onChange={e => set("filling", e.target.value)}>
                  <option value="">Veldu fyllingu</option>
                  {cake.fillings.map(f => <option key={f} value={f}>{f}</option>)}
                </select>
              </div>
            )}

            {/* Botn */}
            {cake.botnar?.length > 0 && (
              <div>
                <label className={LABEL_CLS}>Botn</label>
                <select className={SELECT_CLS} value={draft.bottom} onChange={e => set("bottom", e.target.value)}>
                  <option value="">Veldu botn</option>
                  {cake.botnar.map(b => <option key={b} value={b}>{b}</option>)}
                </select>
              </div>
            )}

            {/* Smjörkrem */}
            {cake.smjorkrem?.length > 0 && (
              <div>
                <label className={LABEL_CLS}>Smjörkrem</label>
                <select className={SELECT_CLS} value={draft.smjorkrem} onChange={e => set("smjorkrem", e.target.value)}>
                  <option value="">Veldu smjörkrem</option>
                  {cake.smjorkrem.map(s => <option key={s} value={s}>{s}</option>)}
                </select>
              </div>
            )}

            {/* Text */}
            <div>
              <label className={LABEL_CLS}>Texti á köku <span className="normal-case font-normal text-stone-400">(valkvætt)</span></label>
              <input className={INPUT_CLS} type="text" value={draft.text} onChange={e => set("text", e.target.value)} placeholder="t.d. Til hamingju!" />
            </div>

            {/* Skreyting */}
            {showSkreyting && (
              <div>
                <label className={LABEL_CLS}>Skreyting <span className="normal-case font-normal text-stone-400">(valkvætt)</span></label>
                <input className={INPUT_CLS} type="text" value={draft.skreyting} onChange={e => set("skreyting", e.target.value)} placeholder="Lýstu skreytingu..." />
              </div>
            )}

            {err && <p className="text-red-500 text-sm font-serif">{err}</p>}

            <div className="flex items-center justify-between mt-auto pt-2">
              {selectedSize ? (
                <span className="text-[#C29979] font-serif font-bold text-xl">{formatISK(selectedSize.price)}</span>
              ) : (
                <span className="text-stone-300 font-serif text-sm">Veldu stærð</span>
              )}
              <button
                type="button"
                onClick={handleAdd}
                className="h-11 px-7 rounded-xl bg-[#C29979] text-white hover:bg-[#b08060] font-serif uppercase text-sm transition-colors"
              >
                Bæta í körfu
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

// ── Page ───────────────────────────────────────────────────────────
const CakeComponent = () => {
  const { items } = useCart();
  const cakeCount = items.filter(i => i.type === "cake").length;
  const [openId, setOpenId] = useState(null);
  const openCake = CAKES.find(c => c.id === openId) ?? null;
  const imagesFor = useMemo(() => (name) => IMAGES_BY_NAME[name] ?? [], []);

  // Close modal on Escape
  useMemo(() => {
    const handler = (e) => { if (e.key === "Escape") setOpenId(null); };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF7F2]">
      <div className="max-w-6xl mx-auto px-4 py-10">

        {/* Header */}
        <div className="flex items-start justify-between gap-4 mb-6">
          <div>
            <h1 className="text-3xl font-bold text-stone-900 font-serif">Kökur</h1>
            <p className="mt-1 text-stone-500 font-serif text-sm">Veldu köku til að sjá verð og panta.</p>
          </div>
          {cakeCount > 0 && (
            <a href="/karfa" className="flex-shrink-0 flex items-center gap-2 h-10 px-5 rounded-xl bg-[#C29979] text-white hover:bg-[#b08060] font-serif uppercase text-sm transition-colors">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M9 7V6a3 3 0 016 0v1M3 7h18l-2 13H5L3 7z"/></svg>
              Karfa ({cakeCount})
            </a>
          )}
        </div>

        <div className="rounded-xl border border-amber-100 bg-amber-50 px-4 py-3 mb-8">
          <p className="text-stone-500 font-serif text-sm">
            Tveir virkir dagar fyrirvari á öllum pöntunum. Pantanir fyrir helgar og mánudaga þurfa að berast fyrir{" "}
            <span className="text-stone-800 font-semibold">kl. 14 á fimmtudögum</span>.
          </p>
        </div>

        {/* 3-column grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
          {CAKES.map(cake => {
            const cover = (IMAGES_BY_NAME[cake.name] ?? [])[0];
            const fromPrice = cake.size[0]?.price;
            return (
              <button
                key={cake.id}
                type="button"
                onClick={() => setOpenId(cake.id)}
                className="group text-left bg-white rounded-2xl border border-amber-100 shadow-sm overflow-hidden hover:shadow-md hover:border-[#C29979]/40 transition-all"
              >
                <div className="aspect-[4/3] overflow-hidden bg-amber-50">
                  {cover ? (
                    <img
                      src={cover}
                      alt={cake.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center text-stone-200 text-4xl">🎂</div>
                  )}
                </div>
                <div className="px-4 py-3">
                  <p className="font-serif font-semibold text-stone-900 text-sm leading-snug">{cake.name}</p>
                  {fromPrice && (
                    <p className="font-serif text-xs text-[#C29979] mt-0.5">frá {formatISK(fromPrice)}</p>
                  )}
                </div>
              </button>
            );
          })}
        </div>
      </div>

      {/* Modal */}
      {openCake && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm"
          onClick={() => setOpenId(null)}
        >
          <div
            className="bg-white rounded-2xl shadow-xl w-full max-w-3xl max-h-[90vh] overflow-y-auto"
            onClick={e => e.stopPropagation()}
          >
            <div className="flex items-center justify-between px-6 pt-5 pb-3 border-b border-amber-100">
              <h2 className="font-serif font-bold text-stone-900 text-lg">{openCake.name}</h2>
              <button
                type="button"
                onClick={() => setOpenId(null)}
                className="text-stone-400 hover:text-stone-600 text-xl leading-none transition-colors"
              >
                ✕
              </button>
            </div>
            <div className="p-6">
              <CakeDetail
                key={openCake.id}
                cake={openCake}
                images={imagesFor(openCake.name)}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CakeComponent;
